<script setup lang="ts">
/**
 * 未配置区域提醒面板
 *  - 登录后若用户从未选择过任何市 / 区县 → 弹出本面板，引导其去配置可查看详情的区域
 *  - 点击「去配置区域」直接打开个人信息面板的补选区域区段
 */
import { computed } from 'vue';
import { useAuthStore } from '@/stores/auth';

const props = defineProps<{ show: boolean }>();
const emit = defineEmits<{ (e: 'update:show', v: boolean): void; (e: 'open-profile'): void }>();

const auth = useAuthStore();

/** 可解锁的城市个数与区县个数 */
const cityCapacity = computed(() => auth.quotaUsage?.cityCapacity ?? 0);
const countyCapacity = computed(() => auth.quotaUsage?.countyCapacity ?? auth.regionQuota);

function goSetup() {
  emit('update:show', false);
  emit('open-profile');
}
</script>

<template>
  <div class="modal-mask" :class="{ show }" @click.self="emit('update:show', false)">
    <div class="modal setup-modal">
      <div class="modal-head">
        <h3 class="modal-title">📌 设置可查看的机会帐区域</h3>
        <button class="modal-close" @click="emit('update:show', false)">✕</button>
      </div>

      <div class="modal-body">
        <p class="setup-desc">
          您还没有配置可查看详情的区域。完成设置后即可查看所选城市与区县的完整机会帐资料；
          省级（全省）机会帐所有注册用户均可直接查看。
        </p>

        <div class="setup-quota">
          <div class="setup-quota-item">
            <span>可解锁城市</span>
            <b>{{ cityCapacity }} 个</b>
          </div>
          <div class="setup-quota-item">
            <span>可解锁区县</span>
            <b>{{ countyCapacity }} 个</b>
          </div>
        </div>

        <p class="setup-tip">
          具体解锁哪些城市与区县由您自行选择；<b>提交后不可自行更改</b>，如需调整请联系咨询顾问。
        </p>

        <div class="setup-actions">
          <button class="btn btn-primary" @click="goSetup">去设置区域</button>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.setup-modal { width: 460px; max-width: calc(100vw - 32px); }
.setup-desc {
  font-size: 13px;
  color: var(--text-sub, #556664);
  line-height: 1.85;
  margin: 0 0 14px;
}
.setup-quota {
  display: grid; grid-template-columns: 1fr 1fr; gap: 10px;
  background: #f7faf8; border: 1px solid #e4ece8; border-radius: 8px;
  padding: 12px 14px; margin-bottom: 14px;
}
.setup-quota-item { display: flex; flex-direction: column; gap: 4px; }
.setup-quota-item span { font-size: 11.5px; color: var(--text-weak, #8a9a97); }
.setup-quota-item b { font-size: 16px; color: var(--brand-dark, #123527); font-weight: 700; }
.setup-tip {
  font-size: 12px; color: var(--text-weak, #8a9a97);
  line-height: 1.75; margin: 0 0 4px;
}
.setup-tip b { color: var(--hot, #c93d77); }
.setup-actions { display: flex; justify-content: flex-end; gap: 10px; margin-top: 16px; }
</style>
